/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./human.vue?vue&type=template&id=ceced9fe&scoped=true"
import script from "./human.vue?vue&type=script&lang=js"
export * from "./human.vue?vue&type=script&lang=js"
import style0 from "./human.vue?vue&type=style&index=0&id=ceced9fe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ceced9fe",
  null
  
)

export default component.exports